import { projectName } from "@hex-insights/verita-romania.shared";

const romaniaContractPaymentOptions: Record<number, string[]> = {
	1: ["2024-08-15T00:00:00Z"],
	2: ["2024-08-15T00:00:00Z", "2025-01-31T00:00:00Z"],
	4: ["2024-08-15T00:00:00Z", "2024-10-31T00:00:00Z", "2025-01-31T00:00:00Z", "2025-04-30T00:00:00Z"],
	9: [
		"2024-08-15T00:00:00Z",
		"2024-09-30T00:00:00Z",
		"2024-10-31T00:00:00Z",
		"2024-11-30T00:00:00Z",
		"2024-12-31T00:00:00Z",
		"2025-01-31T00:00:00Z",
		"2025-02-28T00:00:00Z",
		"2025-03-31T00:00:00Z",
		"2025-04-30T00:00:00Z",
	],
};

const greeceContractPaymentOptions: Record<number, string[]> = {};

export const contractPaymentOptions =
	projectName === "verita-romania" ? romaniaContractPaymentOptions : greeceContractPaymentOptions;
